<template>
  <div class="input-group">
    <input v-if="!enableMultiLine"
      v-model="url"
      ref="urlInput"
      :name="name"
      placeholder="https://ringba.com"
      autocomplete="off"
      class="form-control code-input"
      :class="customClass"
    >
    <textarea v-else
      v-model="url"
      ref="urlInput"
      :name="name"
      placeholder="https://ringba.com"
      autocomplete="off"
      class="form-control"
      rows="1"
      :class="customClass"
    ></textarea>
    <div class="input-group-btn vertical-top">
      <button
        :id="tokenButtonUrl"
        :ref="tokenButtonUrl"
        v-t="'TOKEN'"
        class="btn btn-secondary"
        type="button"
        @click="toggleMacrosPopover"
      />
    </div>
    <popover
      v-model="showMacrosPopover"
      custom-class="breakdown-legend__popover"
      placement="bottom"
      trigger="manual"
      :target="'#' + tokenButtonUrl"
      @show="tagsPopoverVisible = true"
      @hide="tagsPopoverVisible = false"
    >
      <template slot="popover">
        <MacroSelectionPopover
          :focus-dropdown="tagsPopoverVisible"
          :trigger-element="$refs[tokenButtonUrl]"
          :macros="macros"
          @blur="showMacrosPopover = false"
          @selected-tag="onSelectedTag"
        />
      </template>
    </popover>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { GET_MACROS } from '@/modules/info/store/actionTypes';
import MacroSelectionPopover from '@/core/components/MacroSelectionPopover';
import { uniqueId } from 'lodash';

export default {
  name: 'HttpUrl',
  components: { MacroSelectionPopover },
  props: {
    name: {
      type: String,
      default: null,
    },
    value: {
      type: String,
      default: null
    },
    customClass: {
      type: String,
      default: ''
    },
    enableMultiLine: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('info', ['macros']),
    url: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  data() {
    return {
      tagsPopoverVisible: false,
      showMacrosPopover: false,
      tokenButtonUrl: this.generateRandomRefForToken(),
    };
  },
  watch: {
    url: {
      immediate: true,
      handler() {
        this.adjustTextarea();
      }
    }
  },
  async mounted() {
    this.adjustTextarea();
    await this.getMacros();
  },
  methods: {
    ...mapActions('info', { 'getMacros': GET_MACROS }),
    toggleMacrosPopover() {
      this.showMacrosPopover = !this.showMacrosPopover;
      return;
    },
    adjustTextarea () {
      // Wrapped in nextTick to ensure that the textarea has been rendered
      this.$nextTick(() => {
        if (!this.enableMultiLine) return;

        const urlInput = this.$refs.urlInput;

        if (urlInput) {
            const inputHeight = urlInput.scrollHeight + 5;
            const needsAdjusted = urlInput.scrollHeight > urlInput.clientHeight;
            if (needsAdjusted) {
              urlInput.style.height = `${inputHeight}px`;
            }
        }
      });
    },
    onSelectedTag(tag) {
      const urlInput = this.$refs.urlInput;
      const cursorPosition = urlInput.selectionStart;
      this.showMacrosPopover = false;
      const tagToAdd = tag.originalTag.macro;
      this.url = this.url ? this.url.substring(0, cursorPosition) + tagToAdd + this.url.substring(cursorPosition) : tagToAdd;
      this.$nextTick(() => {
        urlInput.focus();
        urlInput.selectionStart = cursorPosition + tagToAdd.length;
        urlInput.selectionEnd = cursorPosition + tagToAdd.length;
      });
    },
    generateRandomRefForToken() {
      return uniqueId('tokenButtonUrl')
    }
  }
};


</script>
